import http from "./http";

// 获取方向列表      /pc/learningDirection/list
function learningDirection(pageNumber = 1, pageSize = 1000000) {
    let url = `/api/pc/learningDirection/list?pageSize=${pageSize}&pageNum=${pageNumber}`;

    return http.post(url, {})
}


//方向详情   /pc/learningDirection/detail/{directionId}
function learningDirectionDetail(directionId) {
    let url = `/api/pc/learningDirection/detail/${directionId}`;
    return http.get(url)
}

// 创建订单（学习方向） /pc/order/direction/order/create/{directionId}
function directionOrderCreate(directionId) {
    let url = `/api/pc/order/direction/order/create/${directionId}`;
    // const formdata = new FormData();
    // formdata.append("type", type);

    return http.post(url, {})
}


export {
    learningDirection, learningDirectionDetail, directionOrderCreate
}
